import { ConfigProvider, App as AntdApp } from 'antd'

import { Router } from '@eastcoal/router/components/Router'
import { ApplicationType } from '@eastcoal/shared/enums/ApplicationType'
import { DeviceType } from '@eastcoal/shared/enums/DeviceType'
import { useAppRefreshSubscriber } from '@eastcoal/shared/hooks/useAppRefresh'

import { antdConfig } from './config/antd'
import { routes } from './routes'
import { APP_VERSION } from './utils/constants'

export const App = () => {
  useAppRefreshSubscriber({
    deviceType: DeviceType.PC,
    app: ApplicationType.OPERATION,
    version: APP_VERSION
  })
  return (
    <ConfigProvider {...antdConfig}>
      <AntdApp>
        <Router items={routes} />
      </AntdApp>
    </ConfigProvider>
  )
}
